import { useState } from "react";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Reveal } from "@/components/landing/primitives";
import { FREE_TOOLS } from "@/components/landing/freeTools";

export const FreeToolsModal = ({ open, onClose }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="free-tools-modal" className="max-h-[90dvh] max-w-3xl overflow-y-auto rounded-none border border-white/[0.10] bg-[#0B0C0F] p-0 text-[#ECEBE4]">
      <div className="p-6 md:p-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-[#5A6170]">Free tools · no card · no trial</p>
        <DialogTitle className="mt-3 font-display text-2xl font-semibold tracking-[-0.02em] md:text-3xl">Everything you can use today, free.</DialogTitle>
        <DialogDescription className="mt-2 text-[15px] text-[#9DA3AE]">Pick a tool. Each one opens live.</DialogDescription>
        <div className="mt-7 grid gap-px border border-white/[0.07] bg-white/[0.07] sm:grid-cols-2">
          {FREE_TOOLS.map((x) => (
            <a key={x.id} href={x.href} data-testid={`free-tool-${x.id}`} className="group flex items-start gap-4 bg-[#0B0C0F] p-5 transition-colors hover:bg-[#111317]">
              <x.Icon size={17} className="mt-0.5 shrink-0 text-white/30 transition-colors group-hover:text-[#BACD1C]" />
              <span className="min-w-0 flex-1">
                <span className="flex items-center justify-between text-[15px] font-medium text-[#ECEBE4]">{x.t}<ArrowUpRight size={14} className="text-white/25 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[#ECEBE4]" /></span>
                <span className="mt-1 block text-[13px] text-[#7D8390]">{x.d}</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export const FreeToolsHero = () => {
  const [open, setOpen] = useState(false);
  return (
    <section data-testid="free-tools-hero" className="border-y border-white/[0.06] bg-[#0B0C0F]">
      <Reveal className="mx-auto flex max-w-[1400px] flex-col gap-6 px-6 py-10 md:flex-row md:items-center md:justify-between md:px-12">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-[#5A6170]">{FREE_TOOLS.length} free tools · live now</p>
          <h2 className="mt-2 font-display text-2xl font-semibold tracking-[-0.03em] text-[#ECEBE4] md:text-3xl">Start using our free tools. <span className="text-[#7D8390]">No card, no trial.</span></h2>
          <div className="mt-4 flex flex-wrap gap-x-4 gap-y-1.5 font-mono text-[11px] text-[#5A6170]">
            {FREE_TOOLS.map((x) => <span key={x.id}>{x.t}</span>)}
          </div>
        </div>
        <button type="button" onClick={() => setOpen(true)} data-testid="free-tools-open-btn" className="group inline-flex shrink-0 items-center justify-center gap-2 border border-white/25 px-7 py-4 font-mono text-[13px] uppercase tracking-[0.14em] text-[#ECEBE4] transition-[border-color,background-color] duration-300 hover:border-white/50 hover:bg-white/[0.04]">
          Open all free tools <ArrowRight size={16} className="transition-transform group-hover:translate-x-0.5" />
        </button>
      </Reveal>
      <FreeToolsModal open={open} onClose={() => setOpen(false)} />
    </section>
  );
};
